export default __webpack_public_path__ + "static/media/warning.38b4a2a1.svg";